//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import PublicService from '@/service/public'

import HouseItem from '@/components/business/house_item'

import TopFilter from '@/components/buildings_top_filter/index'
import Search from './_search'

import TagFilter from './_tag_filter'

import PageTopFilter from '@/common/mixins/page_top_filter'
import Pagination from '@/common/mixins/pagination'

const tags = [
    {
        name: '最近热门',
        value: '',
        class_name: 'hot'
    },
    {
        name: '人气最高',
        value: 'view_count',
        class_name: 'popular'
    },
    {
        name: '评论最多',
        value: 'comment_count',
        class_name: 'coments'
    }
]

export default {
    mixins: [
        PageTopFilter,
        Pagination
    ],
    data () {
        return {
            filter_tabs: ['区域', '户型', '面积'],
            zone_ids: '',
            zone_section_ids: '',
            area: '',
            layout: '',
            metro: '',
            hotpage_banner: [],
            banner_loading: true,
            recommendation: [],
            interesting_order: '',
            tags
        }
    },
    computed: {
        show_recommendation () {
            return [
                'decoration',
                'zone_ids',
                'zone_section_ids',
                'area',
                'total_price',
                'price',
                'layout',
                'metro',
                'interesting_order'
            ].every(key => !this[key])
        }
    },
    created () {
        this.getRecommendation()
    },
    methods: {
        getRecommendation () {
            const options = {}
            if (this.zone_ids) {
                options.zones = this.zone_ids
            }
            this.getData()
        },
        changeFilter (filter) {
            Object.keys(filter).forEach((key) => {
                console.error(filter)
                this[key] = filter[key]
            })
            this.page = 1
            this.resetList()
            this.getData()
        },
        resetList () {
            this.recommendation = []
            this.items = []
        },
        changeTag (tag) {
            if (tag === this.interesting_order) {
                return
            }
            this.interesting_order = tag
            this.page = 1
            this.resetList()
            this.getData()
        },
        checkTopFilterPosition () {
            if (this.page === 1) {
                window.scrollTo(0, 0)
            }
        },
        async getData () {
            this.loading = true
            const options = {
                page: this.page,
                status: '热门楼盘'
            }
            const filters = ['zone_ids', 'zone_section_ids', 'metro', 'area', 'price', 'total_price', 'layout', 'decoration', 'interesting_order']
            let has_filter = false
            filters.forEach((key) => {
                if (this[key]) {
                    options[key] = this[key]
                    has_filter = true
                }
            })
            if (this.show_recommendation) {
                options.exclude_ids = this.recommendation.map(({ building_id}) => building_id).join(',')
            }
            const data = await Service.getBuildings(options)
            this.handleData(data)
            this.$nextTick(this.checkTopFilterPosition)
        },
        searchClick () {
            this.$router.push({
                name: 'search',
                query: {
                    type: '热门楼盘'
                }
            })
        }
    },
    components: {
        HouseItem,
        TopFilter,
        TagFilter,
        Search
    }
}
